import styled from "styled-components";

const ProfileSection = styled.div`
    grid-area: profile;
    top: 0;
    position: sticky;
    background-color: #fff;
`;

export default ProfileSection;